import { render, staticRenderFns } from "./StaffPermSettingBox.vue?vue&type=template&id=3104c004"
import script from "./StaffPermSettingBox.vue?vue&type=script&lang=js"
export * from "./StaffPermSettingBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports